import PropTypes from "prop-types"
import React from "react"
import { Route, Switch } from "react-router"
import styled from "styled-components"

import LoggedApp from "./LoggedApp"

// ----------------------------------------------------------------------------

function UserApp(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    // ----------------------------------------------------------------------------
    // Not authenticated
    // ----------------------------------------------------------------------------

    // if (!user)
    //     return (
    //         <Switch>
    //             <Route path="/" component={UserAuthPage} />
    //         </Switch>
    //     )

    // ----------------------------------------------------------------------------
    // Authenticated
    // ----------------------------------------------------------------------------

    return (
        <Switch>
            <Route path={`/`} component={LoggedApp} />
        </Switch>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

UserApp.propTypes = {
    className: PropTypes.string.isRequired,
}

UserApp.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledUserApp = styled(UserApp)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default StyledUserApp
